import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const AssetModalMobileTabNavigation = /*#__PURE__*/ memo((param)=>{
    let { tabs } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "flex h-14 w-full shrink-0 items-center justify-around bg-grey-1 [&_.isEmpty]:justify-end",
        children: tabs
    });
});
AssetModalMobileTabNavigation.displayName = "AssetModalMobileTabNavigation";
